export const isProduction = process.env.REACT_APP_ENV === 'production'
export const isStaging = process.env.REACT_APP_ENV === 'staging'
export const isDemo = process.env.REACT_APP_ENV === 'demo'
export const isDev = process.env.NODE_ENV === 'development'

export const getReactAppBaseUrl = () => process.env.REACT_APP_BASE_URL
export const getReactAppEnv = () => process.env.REACT_APP_ENV
